var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 13h4v4H0z",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  attributeType: "XML",
  begin: "0s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0.2; 1; .2"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  begin: "0s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "10; 20; 10"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  begin: "0s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "10; 5; 10"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 13h4v4h-4z",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  attributeType: "XML",
  begin: "0.15s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0.2; 1; .2"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  begin: "0.15s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "10; 20; 10"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  begin: "0.15s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "10; 5; 10"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24 13h4v4h-4z",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  attributeType: "XML",
  begin: "0.3s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0.2; 1; .2"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  begin: "0.3s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "10; 20; 10"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  begin: "0.3s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "10; 5; 10"
}))));
export default SvgLoading;